import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';
export const DealerLocatorFiltersServiceOfferings = ({ title, children }) => {
    return (_jsxs("div", { children: [_jsx("p", { className: cx(styles['dealer-locator-text'], 'cat-u-theme-typography-label-lg mb-0'), children: title }), children] }));
};
